<template>
    <DCard
        :title="
            __('messages.dashboard.widgets.news.title') + ' - ' + __('messages.dashboard.widgets.news.description')"
        class="height p-3"
    >
        <DRow
            class="main-card p-3"
        >
            <div>
                <DRichTextEditor
                    v-if="message !== ''"
                    :content="message"
                    theme="bubble"
                    readOnly
                />
            </div>
            <div>
                <DButton
                    v-if="userPermissions.includes('widget.news_manage')"
                    :label="__('messages.dashboard.widgets.news.edit')"
                    color="secondary"
                    icon="pencil"
                    class="mt-3"
                    @click="handleEditMessage"
                />
            </div>
        </DRow>
        <EditMessageModal
            v-if="showEditMessageModal"
            :old-message="message"
            :show-modal="showEditMessageModal"
            @close-modal="showEditMessageModal=false"
        />
    </DCard>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { route } from '~@/Composables/route'

import { __ } from '~@/Composables/translation'
import EditMessageModal from './EditMessageModal.vue'
import { usePage } from '@inertiajs/vue3'

const message = ref('')
const backupMessage = ref({
    ops: [
        {
            insert: __('messages.dashboard.widgets.news.no_news')
        }
    ]
})
const showEditMessageModal = ref(false)
const userPermissions = computed(() => usePage().props.auth.permissions)
onMounted(async () => {
    window.axios.get(route('widgets.get-data'), {
        params: {
            widget: 'news'
        }
    })
        .then(response => {
            message.value = JSON.parse(response.data.data.message) ?? backupMessage.value
        })
})

function handleEditMessage () {
    showEditMessageModal.value = true
}

</script>
<style>
.table th {
    border-top: 0;
}
.main-card {
    padding-top: 15px;
}
</style>
